import { render } from "./SelectionChatUserList.vue?vue&type=template&id=2a59e4c4"
import script from "./SelectionChatUserList.vue?vue&type=script&lang=js"
export * from "./SelectionChatUserList.vue?vue&type=script&lang=js"
script.render = render

export default script